export default "__VITE_ASSET__c91f3d73__"